import { create } from "zustand";
import { useNavigate } from "react-router";
import { Modal } from "../../../DesignSystem";

type Store = {
    title: string;
    message: string;
    options?: { hideUsage: boolean };
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    showUpgradeModal: (title: string, message: string, options?: { hideUsage: boolean }) => void;
};

export const useMeteringUpgradeModal = create<Store>()((set, get) => ({
    title: "Title",
    message: "Message",
    isOpen: false,
    options: { hideUsage: false },
    setIsOpen(shown) {
        set({ isOpen: shown });
    },
    showUpgradeModal(title: string, message: string, options?: { hideUsage: boolean }) {
        set({ title, message, isOpen: true, options });
    },
}));

const MeteringUpgradeModal = () => {
    const { isOpen, setIsOpen, title, message, options } = useMeteringUpgradeModal();
    const navigate = useNavigate();

    return (
        <Modal
            open={isOpen}
            onClose={() => setIsOpen(false)}
            className="relative"
            title={title}
            description={message}
            primaryButton={{
                color: "blueGradient",
                text: "Upgrade",
                icon: <img src="https://app.purchaser.ai/images/icons/upgrade-light.svg" className="h-4 w-4" />,
                onClick: () => {
                    setIsOpen(false);
                    navigate("/pricing");
                },
                className: "py-1",
            }}
            secondaryButton={
                !options?.hideUsage
                    ? {
                          color: "clear",
                          text: "View Usage",
                          href: "/team/usage",
                          className: "py-1",
                          onClick: () => {
                              setIsOpen(false);
                          },
                      }
                    : undefined
            }
        />
    );
};

export default MeteringUpgradeModal;
